<template>
  <v-dialog v-model="config.loading" persistent fullscreen content-class="loading-dialog">
    <v-container fill-height>
      <v-layout row justify-center align-center>
        <v-progress-circular indeterminate :size="100" :width="7" color="#f2f2f2"></v-progress-circular>
      </v-layout>
    </v-container>
  </v-dialog>
</template>

<script>
export default {
  name: "Loader",
  props: ["config", "bgcolorx"],
  data() {
    return {
      dialog: false,
    };
  },
};
</script>